import { Router as ReachRouter } from '@reach/router';
import type { RouteComponentProps } from '@reach/router';
import { type FC, useMemo } from 'react';
import styled from 'styled-components';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';

import { useCompaniesRoutes } from '../hooks/use-companies-routes/use-companies-routes';
import { AuthenticatedRoute } from './authenticated-route/authenticated-route';

const RouterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Router: FC = () => {
  const { isLoggedIn } = useLoginState();
  const { routes } = useCompaniesRoutes();

  const routesToRender = useMemo(
    () =>
      routes.map(({ onlyAuthenticated, path, Component }) => {
        const RouteComponent: FC<RouteComponentProps> = onlyAuthenticated
          ? () => <AuthenticatedRoute component={<Component />} />
          : Component;

        return {
          Route: RouteComponent,
          path: path.replace(/^\/companies(\/?)/, '/'),
        };
      }),
    [isLoggedIn]
  );

  return (
    <ReachRouter component={RouterWrapper}>
      {routesToRender.map(({ Route, path }) => (
        <Route key={path} path={path} />
      ))}
    </ReachRouter>
  );
};
